import { render, staticRenderFns } from "./BandejaMotivoRechazoComponente.vue?vue&type=template&id=09cedbc2"
import script from "./BandejaMotivoRechazoComponente.vue?vue&type=script&lang=js"
export * from "./BandejaMotivoRechazoComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports